import TemplatesTable from '../organisms/TemplatesTable';
import { Loader } from '@common/ui/Loader';
import useTemplatesTable from '@MyRequests/hooks/use-templates-table';
import { EmptyState } from '@common/components/EmptyState';
import NewRequest from '@common/layouts/AppLayout/components/NewRequest';

export default function TemplatesPage() {
  const { isFetched, isLoading, pageData, handleOnPageChange } = useTemplatesTable();
  if (!isFetched) {
    return <Loader />;
  }

  if (!pageData || pageData.data.length === 0) {
    return (
      <EmptyState
        title="You don't have any favorites yet"
        imgSrc="/static/illustrations/not-found.svg"
        body="Create a new request and save it as a favorite"
        action={<NewRequest />}
      />
    );
  }

  return <TemplatesTable isLoading={isLoading} pageData={pageData} handleOnPageChange={handleOnPageChange} />;
}
